import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {  MatFormFieldModule } from '@angular/material/form-field';
import {  MatButtonModule } from '@angular/material/button';
import {  MatInputModule } from '@angular/material/input';
import { ClipboardModule } from 'ngx-clipboard';
import { VisitorIntelScriptComponent } from './visitor-intel-script.component';
import { IsFeatureFlagEnabledPipeModule } from '../../pipes';

@NgModule({
  declarations: [VisitorIntelScriptComponent],
  exports: [VisitorIntelScriptComponent],
  imports: [
    CommonModule,
    IsFeatureFlagEnabledPipeModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatButtonModule,
    ClipboardModule,
    MatInputModule,
  ],
})
export class VisitorScriptModule {}
